<div class="chart-card">
    <h3 class="chart-title">{{ 'user_records.analytics.card_registrations_trend_title' | translate }}</h3>
    <div class="chart-container">
        <canvas baseChart *ngIf="data.length > 0" type="line" [data]="chartData" [options]="chartOptions"></canvas>
        <div *ngIf="data.length === 0" class="no-data">{{ 'user_records.analytics.no_data' | translate }}</div>
    </div>
</div>
